import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

import HeaderAndSearch from "./HeaderAndSearch";
import HomeCarousel from "./HomeCarousel";
import HowToUse from "./HowToUse";
import HomeTheEasyWay from "./HomeTheEasyWay";
import HomeBetterWay from "./HomeBetterWay";
import HomeOurValues from "./HomeOurValues";
import HomeFacilities from "./HomeFacilities";
import HomeGuidebook from "./HomeGuidebook";
import HomeCreateAccount from "./HomeCreateAccount";
import SeoLinks from "./SeoLinks";
import AsSeenOn from "./AsSeenOn";

import HomeFooter from "./HomeFooter";
import NeedHelpBanner from "./NeedHelpBanner";

import HelpDialog from "../helpDialog/HelpDialog";
import { useOpenHelpDialogOnScroll } from "../helpDialog/useOpenHelpDialogOnScroll";

import PurpleDoorLogoRect from "../Logo/PurpleDoorLogoRect";

const Home = ({ redirectToHome }) => {
    const router = useRouter();
    const [helpDialogOpen, setHelpDialogOpen] = useState(false);
    const [helpButtonMinimized, setHelpButtonMinimized] = useState(false);

    useEffect(() => {
        if (redirectToHome) {
            router.replace("/");
        }
    }, []);

    // Open help dialog once the user scrolls, if it hasn't been shown in the last hour
    useOpenHelpDialogOnScroll(setHelpDialogOpen);

    const handleMinimizeHelpButton = (e) => {
        e.stopPropagation(); // Prevent the button's onClick from firing
        setHelpButtonMinimized(true);
    };

    const handleOpenHelpDialog = () => {
        // Always open the dialog and update the timestamp
        setHelpDialogOpen(true);
        localStorage.setItem("lastHelpDialogShown", Date.now().toString());

        // If button was minimized, expand it
        if (helpButtonMinimized) {
            setHelpButtonMinimized(false);
        }
    };

    return (
        <div>
            <HeaderAndSearch />

            <div className="bg-white">
                <div className="container mx-auto px-4 sm:px-16">
                    <div className="hidden sm:block">
                        <HomeCarousel />
                    </div>
                </div>

                <NeedHelpBanner />

                <div className="mt-4 sm:mt-8 container mx-auto px-0 sm:px-16">
                    {/*<HowToUse />*/}
                    <HomeTheEasyWay />
                    <HomeBetterWay />
                </div>

                <HomeOurValues />

                <AsSeenOn />
            </div>

            <SeoLinks />
            <HomeFooter />

            {/* Floating Help Button */}
            <button
                onClick={handleOpenHelpDialog}
                className={`fixed bottom-6 right-6 ${
                    helpButtonMinimized ? "w-16" : "w-72"
                } flex items-center justify-between bg-[#FBAA37] hover:bg-[#EB9A27] text-black p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-200 hover:scale-105 focus:outline-none`}
                aria-label="Open Help"
            >
                <div className="flex items-center space-x-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-8 w-8"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M12 21a9 9 0 100-18 9 9 0 000 18z"
                        />
                    </svg>

                    {!helpButtonMinimized && (
                        <div className="font-bold text-xl">How can we help?</div>
                    )}
                </div>

                {!helpButtonMinimized && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 cursor-pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        onClick={handleMinimizeHelpButton}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                )}
            </button>

            <HelpDialog open={helpDialogOpen} setOpen={setHelpDialogOpen} />
        </div>
    );
};

export default Home;
